import React, { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import {
  ModalBody,
  InputLabel,
  Container,
  InputContainer,
  ModalContainer,
  InputRow,
  AdduserSec,
  WarningLabel,
} from './styles';
import { addNewPrinter, validatePrinterConnection } from '../../utils/services/mailRoomAPI';
import { withTranslation } from 'react-i18next';
import { ADD_NEW_PRINTER_CONFIGURATION_MODAL as trans } from '../../containers/UserSettingsPage/TranslationValues';

const REGEX_PRINTER_NAME = new RegExp(/^[^\\\/\#?\s'"]{0,127}$/);
const NAMESPACE = ['ADD_NEW_PRINTER_CONFIGURATION_MODAL'];

const PrinterConfigModal = props => {
  const { onCancel, onSuccess, target, t } = props;
  const [loading, setLoading] = useState(false);
  const { printerName, printerIPAddress } = target;
  const [isValidPrinter, setValidPrinter] = useState(false);
  const [printerDetails, setprinterDetails] = useState({
    printerName,
    printerIPAddress,
  });
  const [warningText, setWarningText] = useState({
    printerName: '',
    printerIPAddress: '',
  });
  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      validateDetails(!isValidPrinter);
    }
  };

  const handleChange = e => {
    const { value, name } = e.target;
    setprinterDetails({ ...printerDetails, [name]: value });
    setValidPrinter(false);
    isValidInput(value, name);
  };

  const isValidInput = (value, name) => {
    if (name === 'printerIPAddress') {
      const isValidIP = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        value,
      );
      setWarningText({
        ...warningText,
        printerIPAddress: !isValidIP ? t(trans.EMPTY_IP_ADDRESS_WARNING_MESSAGE.key,trans.EMPTY_IP_ADDRESS_WARNING_MESSAGE.value) : '',
      });
    } else if (name === 'printerName') {
      let invalidChars = [
        { char: '#', error: 'hash(#)' },
        { char: "'", error: "single quotes(')" },
        { char: '"', error: 'double quotes(")' },
        { char: '\\', error: 'backSlash(\\)' },
        { char: '/', error: 'forward slash(/)' },
        { char: '?', error: 'question mark(?)' },
        { char: ' ', error: 'space' },
      ];
      const isValidChar = [];
      invalidChars.map((chars, key) => {
        if (value.includes(chars.char)) {
          isValidChar.push(chars);
          return isValidChar;
        }
      });
      const isValidPrinterName = REGEX_PRINTER_NAME.test(value);
      setWarningText({
        ...warningText,
        printerName: !isValidPrinterName
        ? isValidChar.length > 0
          ? t(trans.INVALID_PRINTER_NAME_WARNING_MESSAGE.key,trans.INVALID_PRINTER_NAME_WARNING_MESSAGE.value) + ' ' + isValidChar[0].error
          : t(trans.PRINTER_NAME_EXCEDED_MAXIMUM_LENGTH_WARNING_MESSAGE.key,trans.PRINTER_NAME_EXCEDED_MAXIMUM_LENGTH_WARNING_MESSAGE.value)
        : '',
      });
    }
  };

  const onSave = async () => {
    setLoading(true);
    let response = await addNewPrinter(printerDetails);
    if (response) {
      setLoading(false);
      if (response.errors.length < 1) {
        message.success(t(trans.NEW_PRINTER_ADDED_SUCCESS_MESSAGE.key,trans.NEW_PRINTER_ADDED_SUCCESS_MESSAGE.value));
        onSuccess();
        onCancel();
      }
    }
  };

  const validateDetails = async (isTestConnection = false) => {
    if (
      printerDetails.printerName &&
      printerDetails.printerIPAddress &&
      !warningText.printerName &&
      !warningText.printerIPAddress
    ) {
      if (isTestConnection) {
        testConnection();
      } else {
        onSave();
      }
    } else {
      setWarningText({
        ...warningText,
        printerName: warningText.printerName
          ? warningText.printerName
          : !printerDetails.printerName
          ? t(trans.EMPTY_PRINTER_NAME_WARNING_MESSAGE.key,trans.EMPTY_PRINTER_NAME_WARNING_MESSAGE.value)
          : '',
        printerIPAddress: warningText.printerIPAddress
          ? warningText.printerIPAddress
          : !printerDetails.printerIPAddress
          ? t(trans.EMPTY_IP_ADDRESS_WARNING_MESSAGE.key,trans.EMPTY_IP_ADDRESS_WARNING_MESSAGE.value)
          : '',
      });
    }
  };

  const testConnection = async () => {
    setLoading(true);
    let response = await validatePrinterConnection(printerDetails);
    if (response) {
      setLoading(false);
      if (response && response.errors && response.errors.length === 0) {
        if (response.statusCode === 1552) {
          message.success(t(trans.NEW_PRINTER_CONNECTION_VALIDATION_SUCCESS_MESSAGE.key,trans.NEW_PRINTER_CONNECTION_VALIDATION_SUCCESS_MESSAGE.value));
        }
        setValidPrinter(true);
      }
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div>{t(trans.ADD_NEW_PRINTER_CONFIGURATION_MODAL_TITLE.key,trans.ADD_NEW_PRINTER_CONFIGURATION_MODAL_TITLE.value)}</div>
          </div>
        }
        visible={true}
        maskClosable={false}
        width={600}
        centered
        onCancel={onCancel}
        footer={[
          <Button
            key="Add User"
            type="primary"
            // disabled={}
            loading={loading}
            onClick={() => validateDetails(!isValidPrinter)}
          >
            {isValidPrinter ? t(trans.ADD_NEW_TESTED_PRINTER_BUTTON.key,trans.ADD_NEW_TESTED_PRINTER_BUTTON.value) : t(trans.TEST_NEW_PRINTER_CONNECTION_BUTTON.key,trans.TEST_NEW_PRINTER_CONNECTION_BUTTON.value)}
          </Button>,
        ]}
      >
        <ModalBody>
          <AdduserSec style={{ width: '100%' }}>
            <ModalContainer user={1}>
              <InputRow>
                <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.ADD_NEW_PRINTER_NAME_LABEL.key,trans.ADD_NEW_PRINTER_NAME_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(trans.ADD_NEW_PRINTER_NAME_PLACEHOLDER.key,trans.ADD_NEW_PRINTER_NAME_PLACEHOLDER.value)}
                    name="printerName"
                    value={printerDetails.printerName}
                    onChange={handleChange}
                    autoComplete={'off'}
                  />
                  <WarningLabel>{warningText.printerName}</WarningLabel>
                </InputContainer>
              </InputRow>
              <InputRow>
                <InputContainer className="full-width" user={1}>
                <InputLabel>{t(trans.ADD_NEW_IP_ADDRESS_LABEL.key,trans.ADD_NEW_IP_ADDRESS_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(trans.ADD_NEW_IP_ADDRESS_PLACEHOLDER.key,trans.ADD_NEW_IP_ADDRESS_PLACEHOLDER.value)}
                    name="printerIPAddress"
                    value={printerDetails.printerIPAddress}
                    onChange={handleChange}
                    autoComplete={'off'}
                    required="true"
                    pattern="RegExp(/\d+/g)"
                  />
                  <WarningLabel>{warningText.printerIPAddress} </WarningLabel>
                </InputContainer>
              </InputRow>
            </ModalContainer>
          </AdduserSec>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACE)(PrinterConfigModal);
